import { QueryClient } from "@tanstack/react-query";
import { redirect } from "react-router-dom";
import { getCabinetQueryOptions } from "@/entities/cabinet/api/getCabinetQueryOptions";

export const mediationLoader = (queryClient: QueryClient) => async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return redirect("/auth", { status: 301 });
  }

  const cabinetInformation = await queryClient.fetchQuery(
    getCabinetQueryOptions(token),
  );

  const mediationData = cabinetInformation?.data?.agreement?.mediation;

  if (!mediationData) {
    return redirect("/cabinet", { status: 301 });
  }

  return mediationData;
};
